import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, CardBody, Table, Modal, ModalHeader, Button, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import axios from 'axios';
import uuid from 'react-uuid';
import { FaPlus, FaEdit, FaTrash, FaFileExcel } from 'react-icons/fa';
import "../ExternalOrganisation/ExternalOrganisation.css";
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useNavigate, useSearchParams } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const Farm = () => {
    const [farmList, setFarmList] = useState([]);const [loading, setLoading] = useState(true);const [showDeleteItemPopup, setShowDeleteItemPopup] = useState(false);const [deleteItemId, setDeleteItemId] = useState(0);
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId")); const navigate = useNavigate();
    const [name, setName] = useState(''); const [showArchived, setShowArchived] = useState(false);
    const [farmItems, setFarmItems] = useState([]);
    const [farmTempItems, setFarmTempItems] = useState([]);
    const tableRef = useRef(null);
    const [regionalCouncil, setRegionalCouncil] = useState(0); const [regionalCouncilText, setRegionalCouncilText] = useState('All');
    const [catchment, setCatchment] = useState(0); const [catchmentText, setCatchmentText] = useState('All');
    const [supplyCompany, setSupplyCompany] = useState(0); const [supplyCompanyText, setSupplyCompanyText] = useState('All');
    const [ruralProfessionalOrganisation, setRuralProfessionalOrganisation] = useState(0); const [ruralProfessionalOrganisationText, setRuralProfessionalOrganisationText] = useState('All'); 
    const [subscription, setSubscription] = useState(0); const [subscriptionText, setSubscriptionText] = useState('All');
    const [sorting, setSorting] = useState({ key: "firstName", ascending: true }); const [searchParams, setSearchParams] = useSearchParams();
    var filterList = [];
    const populateItemData = async () => {
        try {
            let search = window.location.search;
            let params = new URLSearchParams(search);
            let catchmentValue = params.get('catchment') == null ? 0 : params.get('catchment');
            let supplyCompanyValue = params.get('supplyCompany') == null ? 0 : params.get('supplyCompany');
            let subscriptionValue = params.get('subscription') == null ? 0 : params.get('subscription');
            let ruralProfessionalOrganisationValue = params.get('ruralProfessionalOrganisation') == null ? 0 : params.get('ruralProfessionalOrganisation');
            let regionalCouncilValue = params.get('regionalCouncil') == null ? 0 : params.get('regionalCouncil');
            let nameValue = params.get('name') == null ? '' : params.get('name');
            let showArchivedValue = params.get('showArchived') == null ? false : (params.get('showArchived') === "true");
            setSupplyCompany(params.get('supplyCompany') == null ? 0 : params.get('supplyCompany'));
            setRuralProfessionalOrganisation(params.get('ruralProfessionalOrganisation') == null ? 0 : params.get('ruralProfessionalOrganisation'));
            setSubscription(params.get('subscription') == null ? 0 : params.get('subscription'));
            setRegionalCouncil(params.get('regionalCouncil') == null ? 0 : params.get('regionalCouncil'));
            setCatchment(params.get('catchment') == null ? 0 : params.get('catchment'));
            setName(params.get('name') == null ? '' : params.get('name'));
            setShowArchived(params.get('showArchived') == null ? false : (params.get('showArchived') === "true"));
            if (searchParams.has('supplyCompany')) {
                searchParams.delete('supplyCompany');
                setSearchParams(searchParams);
            }
            if (searchParams.has('ruralProfessionalOrganisation')) {
                searchParams.delete('ruralProfessionalOrganisation');
                setSearchParams(searchParams);
            }
            if (searchParams.has('subscription')) {
                searchParams.delete('subscription');
                setSearchParams(searchParams);
            }
            if (searchParams.has('regionalCouncil')) {
                searchParams.delete('regionalCouncil');
                setSearchParams(searchParams);
            }
            if (searchParams.has('catchment')) {
                searchParams.delete('catchment');
                setSearchParams(searchParams);
            }
            if (searchParams.has('name')) {
                searchParams.delete('name');
                setSearchParams(searchParams);
            }
            if (searchParams.has('showArchived')) {
                searchParams.delete('showArchived');
                setSearchParams(searchParams);
            }
            const response = await apiGet(
                '/api/settings/getfarms/', {
                params: {}
            }
            );
            setFarmList(response.data.content);
            //setFarmItems(response.data.content.farms.filter(x => x.isActive == !showArchived));
            setFarmTempItems(response.data.content.farms);
            var catchmentObj = response.data.content.catchmentList.filter(x => x.id == parseInt(catchmentValue));
            var regionalCouncilObj = response.data.content.regionalCouncilList.filter(x => x.id == parseInt(regionalCouncilValue));
            var supplyCompanyObj = response.data.content.supplyCompanyList.filter(x => x.id == parseInt(supplyCompanyValue));
            var ruralProfessionalOrganisationObj = response.data.content.ruralProfessionalOrganisationList.filter(x => x.id == parseInt(ruralProfessionalOrganisationValue));
            var subscriptionObj = response.data.content.subscriptionList.filter(x => x.id == parseInt(subscriptionValue));
            filterList = [];
            filterList = response.data.content.farms;
            if (catchmentObj.length > 0 && catchmentObj[0].id != 0) {
                setCatchmentText(catchmentObj[0].name);
                filterList = filterList.filter(x => x.catchmentText == catchmentObj[0].name);
                filterList = filterList.filter(x => x.isActive == !showArchivedValue);
                if (nameValue != '') {
                    filterList = filterList.filter(x => (x.uniqueIdentifier.toLowerCase().includes(nameValue.toLowerCase()) || x.name.toLowerCase().includes(nameValue.toLowerCase())));
                }
                if (regionalCouncilObj[0].name != 'All') {
                    await regionalCouncilFilterWithText(regionalCouncilObj[0].name);
                }
                if (supplyCompanyObj[0].name != 'All') {
                    await supplyCompanyFilterWithText(supplyCompanyObj[0].name);
                }
                if (ruralProfessionalOrganisationObj[0].name != 'All') {
                    await ruralProfessionalOrganisationFilterWithText(ruralProfessionalOrganisationObj[0].name);
                }
                if (subscriptionObj[0].name != 'All') {
                    await subscriptionFilterWithText(subscriptionObj[0].name);
                }
            }
            else {
                setCatchmentText('All');
                setSupplyCompanyText(supplyCompanyObj[0].name);
                setRuralProfessionalOrganisationText(ruralProfessionalOrganisationObj[0].name);
                setSubscriptionText(subscriptionObj[0].name);
                setRegionalCouncilText(regionalCouncilObj[0].name);
                filterList = filterList.filter(x => x.isActive == !showArchivedValue);
                if (nameValue != '') {
                    filterList = filterList.filter(x => (x.uniqueIdentifier.toLowerCase().includes(nameValue.toLowerCase()) || x.name.toLowerCase().includes(nameValue.toLowerCase())));
                }
                if (regionalCouncilObj[0].name != 'All') {
                    await regionalCouncilFilterWithText(regionalCouncilObj[0].name);
                }
                if (supplyCompanyObj[0].name != 'All') {
                    await supplyCompanyFilterWithText(supplyCompanyObj[0].name);
                }
                if (ruralProfessionalOrganisationObj[0].name != 'All') {
                    await ruralProfessionalOrganisationFilterWithText(ruralProfessionalOrganisationObj[0].name);
                }
                if (subscriptionObj[0].name != 'All') {
                    await subscriptionFilterWithText(subscriptionObj[0].name);
                }
            }
            setFarmItems(filterList);
            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    useEffect(() => {
        populateItemData();
    }, []);

    function applySorting(key, ascending) {
        setSorting({ key: key, ascending: ascending });
        const currentFarmsCopy = [...farmItems];

        const sortedCurrentFarms = currentFarmsCopy.sort((a, b) => {
            return (a[key] == null ? '' : a[key]).localeCompare((b[key] == null ? '' : b[key]));
        });
        setFarmItems(
            ascending ? sortedCurrentFarms : sortedCurrentFarms.reverse()
        );
    }

    const confirmDeleteItemPopup = async () => {
        const response = await apiGet(
            '/api/settings/DeleteFarm/', {
            params: { Id: deleteItemId, userId: userId }
        }
        );
        setShowDeleteItemPopup(false);
        populateItemData();
    }

    const openDeleteItemPopup = async (item) => {
        setShowDeleteItemPopup(true);
        setDeleteItemId(item.id);
    }

    const closeDeleteItemPopup = async () => {
        setShowDeleteItemPopup(false);
    }

    const handleChangeName = async (event) => {
        setName(event.target.value);
        var list = [];
        list = farmTempItems;
        list = list.filter(x => x.isActive == !showArchived);
        if (event.target.value == '') {
            if (regionalCouncilText != 'All') {
                list = await regionalCouncilFilter(list);
            }
            if (supplyCompanyText != 'All') {
                list = await supplyCompanyFilter(list);
            }
            if (catchmentText != 'All') {
                list = await catchmentFilter(list);
            }
            if (ruralProfessionalOrganisationText != 'All') {
                list = await ruralProfessionalOrganisationFilter(list);
            }
            if (subscriptionText != 'All') {
                list = await subscriptionFilter(list);
            }
            setFarmItems(list)
        }
        else {
            list = list.filter(x => (x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(event.target.value.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(event.target.value.toLowerCase()) : 0));
            if (regionalCouncilText != 'All') {
                list = await regionalCouncilFilter(list);
            }
            if (supplyCompanyText != 'All') {
                list = await supplyCompanyFilter(list);
            }
            if (catchmentText != 'All') {
                list = await catchmentFilter(list);
            }
            if (ruralProfessionalOrganisationText != 'All') {
                list = await ruralProfessionalOrganisationFilter(list);
            }
            if (subscriptionText != 'All') {
                list = await subscriptionFilter(list);
            }
            setFarmItems(list);
        }
    }

    const onRegionalCouncilSelectionChanged = async (e) => {
        filterList = [];
        filterList = farmTempItems;
        setRegionalCouncil(e.target.value);
        setRegionalCouncilText(e.target.selectedOptions[0].text);
        filterList = filterList.filter(x => x.isActive == !showArchived);
        if (e.target.selectedOptions[0].text == 'All') {
            if (name != '') {
                filterList = filterList.filter(x => ( (x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name.toLowerCase().includes(name.toLowerCase()) : 0 )));
            }
            if (supplyCompanyText != 'All') {
                await supplyCompanyFilter();
            }
            if (catchmentText != 'All') {
                await catchmentFilter();
            }
            if (ruralProfessionalOrganisationText != 'All') {
                await ruralProfessionalOrganisationFilter();
            }
            if (subscriptionText != 'All') {
                await subscriptionFilter();
            }
        }
        else {
            filterList = filterList.filter(x => x.regionalCouncilText == e.target.selectedOptions[0].text);
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (supplyCompanyText != 'All') {
                await supplyCompanyFilter();
            }
            if (catchmentText != 'All') {
                await catchmentFilter();
            }
            if (ruralProfessionalOrganisationText != 'All') {
                await ruralProfessionalOrganisationFilter();
            }
            if (subscriptionText != 'All') {
                await subscriptionFilter();
            }
        }
        setFarmItems(filterList);
    }

    const onSupplyCompanySelectionChanged = async (e) => {
        filterList = [];
        filterList = farmTempItems;
        setSupplyCompany(e.target.value);
        setSupplyCompanyText(e.target.selectedOptions[0].text);
        filterList = filterList.filter(x => x.isActive == !showArchived);
        if (e.target.selectedOptions[0].text == 'All') {
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (regionalCouncilText != 'All') {
                await regionalCouncilFilter();
            }
            if (catchmentText != 'All') {
                await catchmentFilter();
            }
            if (ruralProfessionalOrganisationText != 'All') {
                await ruralProfessionalOrganisationFilter();
            }
            if (subscriptionText != 'All') {
                await subscriptionFilter();
            }
        }
        else {
            filterList = filterList.filter(x => x.supplyCompanyText == e.target.selectedOptions[0].text);
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (regionalCouncilText != 'All') {
                await regionalCouncilFilter();
            }
            if (catchmentText != 'All') {
                await catchmentFilter();
            }
            if (ruralProfessionalOrganisationText != 'All') {
                await ruralProfessionalOrganisationFilter();
            }
            if (subscriptionText != 'All') {
                await subscriptionFilter();
            }
        }
        setFarmItems(filterList);
    }

    const onCatchmentSelectionChanged = async (e) => {
        filterList = [];
        filterList = farmTempItems;
        setCatchment(e.target.value);
        setCatchmentText(e.target.selectedOptions[0].text);
        filterList = filterList.filter(x => x.isActive == !showArchived);
        if (e.target.selectedOptions[0].text == 'All') {
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (regionalCouncilText != 'All') {
                await regionalCouncilFilter();
            }
            if (supplyCompanyText != 'All') {
                await supplyCompanyFilter();
            }
            if (ruralProfessionalOrganisationText != 'All') {
                await ruralProfessionalOrganisationFilter();
            }
            if (subscriptionText != 'All') {
                await subscriptionFilter();
            }
        }
        else {
            filterList = filterList.filter(x => x.catchmentText == e.target.selectedOptions[0].text);
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (regionalCouncilText != 'All') {
                await regionalCouncilFilter();
            }
            if (supplyCompanyText != 'All') {
                await supplyCompanyFilter();
            }
            if (ruralProfessionalOrganisationText != 'All') {
                await ruralProfessionalOrganisationFilter();
            }
            if (subscriptionText != 'All') {
                await subscriptionFilter();
            }
        }
        setFarmItems(filterList);
    }
    const regionalCouncilFilterWithText = async (text) => {
        filterList.filter(x => x.regionalCouncilText == text);
    }
    const supplyCompanyFilterWithText = async (text) => {
        filterList.filter(x => x.supplyCompanyText == text);
    }
    const subscriptionFilterWithText = async (text) => {
        filterList.filter(x => x.subscriptionText == text);
    }
    const ruralProfessionalOrganisationFilterWithText = async (text) => {
        filterList.filter(x => x.ruralProfessionalOrganisationText == text);
    }
    const onRuralProfessionalOrganisationSelectionChanged = async (e) => {
        filterList = [];
        filterList = farmTempItems;
        setRuralProfessionalOrganisation(e.target.value);
        setRuralProfessionalOrganisationText(e.target.selectedOptions[0].text);
        filterList = filterList.filter(x => x.isActive == !showArchived);
        if (e.target.selectedOptions[0].text == 'All') {
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (regionalCouncilText != 'All') {
                await regionalCouncilFilter();
            }
            if (supplyCompanyText != 'All') {
                await supplyCompanyFilter();
            }
            if (catchmentText != 'All') {
                 await catchmentFilter();
            }
            if (subscriptionText != 'All') {
                await subscriptionFilter();
            }
        }
        else {
            filterList = filterList.filter(x => x.ruralProfessionalOrganisationText == e.target.selectedOptions[0].text);
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (regionalCouncilText != 'All') {
                await regionalCouncilFilter();
            }
            if (supplyCompanyText != 'All') {
                await supplyCompanyFilter();
            }
            if (catchmentText != 'All') {
                await catchmentFilter();
            }
            if (subscriptionText != 'All') {
                 await subscriptionFilter();
            }
        }
        setFarmItems(filterList);
    }

    const onSubscriptionSelectionChanged = async (e) => {
        filterList = [];
        filterList = farmTempItems;
        setSubscription(e.target.value);
        setSubscriptionText(e.target.selectedOptions[0].text);
        filterList = filterList.filter(x => x.isActive == !showArchived);
        if (e.target.selectedOptions[0].text == 'All') {
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (regionalCouncilText != 'All') {
                await regionalCouncilFilter();
            }
            if (supplyCompanyText != 'All') {
                await supplyCompanyFilter();
            }
            if (ruralProfessionalOrganisationText != 'All') {
                await ruralProfessionalOrganisationFilter();
            }
            if (catchmentText != 'All') {
                await catchmentFilter();
            }
        }
        else {
            filterList = filterList.filter(x => x.subscriptionText == e.target.selectedOptions[0].text);
            if (name != '') {
                filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
            }
            if (regionalCouncilText != 'All') {
                await regionalCouncilFilter();
            }
            if (supplyCompanyText != 'All') {
                await supplyCompanyFilter();
            }
            if (ruralProfessionalOrganisationText != 'All') {
                 await ruralProfessionalOrganisationFilter();
            }
            if (catchmentText != 'All') {
                await catchmentFilter();
            }
        }
        setFarmItems(filterList);
    }

    const regionalCouncilFilter = async () => {
        filterList = filterList.filter(x => x.regionalCouncilText == regionalCouncilText);
    }
    const supplyCompanyFilter = async () => {
        filterList = filterList.filter(x => x.supplyCompanyText == supplyCompanyText);
    }
    const catchmentFilter = async () => {
        filterList = filterList.filter(x => x.catchmentText == catchmentText);
    }
    const ruralProfessionalOrganisationFilter = async () => {
        filterList = filterList.filter(x => x.ruralProfessionalOrganisationText == ruralProfessionalOrganisationText);
    }
    const subscriptionFilter = async () => {
        filterList = filterList.filter(x => x.subscriptionText == subscriptionText);
    }

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'Farms',
        sheet: 'Farms'
    })

    const open = (id, routePath) => {
        window.location = '/' + routePath + '?id=' + id + '&regionalCouncil=' + regionalCouncil + '&name=' + name + '&showArchived=' + showArchived + '&catchment=' + catchment
            + '&supplyCompany=' + supplyCompany + '&ruralProfessionalOrganisation=' + ruralProfessionalOrganisation + '&subscription=' + subscription;
    }
    
    const changeShowArchived = async (e) => {
        setShowArchived(e.target.checked);
        filterList = [];
        filterList = farmTempItems;
        filterList = filterList.filter(x => x.isActive == !e.target.checked);
        if (name != '') {
            filterList = filterList.filter(x => ((x.uniqueIdentifier != null ? x.uniqueIdentifier.toLowerCase().includes(name.toLowerCase()) : 0) || (x.name != null ? x.name.toLowerCase().includes(name.toLowerCase()) : 0)));
        }
        if (regionalCouncilText != 'All') {
            await regionalCouncilFilter();
        }
        if (catchmentText != 'All') {
            await catchmentFilter();
        }
        if (supplyCompanyText != 'All') {
            await supplyCompanyFilter();
        }
        if (ruralProfessionalOrganisationText != 'All') {
            await ruralProfessionalOrganisationFilter();
        }
        if (subscriptionText != 'All') {
            await subscriptionFilter();
        }
        setFarmItems(filterList);
    }

    const exportVineyardToExcel = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleExportVineyardToExcel();
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleExportVineyardToExcel = async (e) => {
        const response = await apiGet(
            '/api/settings/GenerateVineyardExportToExcel/', {
            params: {}
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            var file = new Blob([buffer], { type: "application/vnd.ms-excel" })

            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(file)
            link.download = "Vineyards.xlsx";
            document.body.appendChild(link)
            link.click()
        }

    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header card-header-dark d-flex justify-content-between align-items-center">
                    Vineyards
                    <button type="button" onClick={(id, routePath) => open(0, 'createfarm')} id="btnUpdate" className="btn btn-sm btn-pluse-light">
                        <FaPlus />
                    </button>
                </h2>
                <CardBody>
                    <Row>
                        
                        <Col md="3">
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Regional Council</Label>
                                {farmList.regionalCouncilList == undefined && <p><em>Loading...</em></p>}
                                {farmList.regionalCouncilList != undefined && farmList.regionalCouncilList != null &&
                                    <Input className="validate" type="select" value={regionalCouncil} onChange={e => {
                                        onRegionalCouncilSelectionChanged(e);
                                    }} name="regionalCouncil" id="regionalCouncil">
                                        {farmList.regionalCouncilList.map(items =>
                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                        )}
                                    </Input>
                                }
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Catchment</Label>
                                {farmList.catchmentList == undefined && <p><em>Loading...</em></p>}
                                {farmList.catchmentList != undefined && farmList.catchmentList != null &&
                                    <Input className="validate" type="select" value={catchment} onChange={e => {
                                        onCatchmentSelectionChanged(e);
                                    }} name="catchment" id="catchment">
                                        {farmList.catchmentList.map(items =>
                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                        )}
                                    </Input>
                                }
                            </FormGroup>
                        </Col>
                        <Col md="3" style={{display:"none"}}>
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Supply Company</Label>
                                {farmList.supplyCompanyList == undefined && <p><em>Loading...</em></p>}
                                {farmList.supplyCompanyList != undefined && farmList.supplyCompanyList != null &&
                                    <Input className="validate" type="select" value={supplyCompany} onChange={e => {
                                        onSupplyCompanySelectionChanged(e);
                                    }} name="supplyCompany" id="supplyCompany">
                                        {farmList.supplyCompanyList.map(items =>
                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                        )}
                                    </Input>
                                }
                            </FormGroup>
                        </Col>
                        <Col md="3" className="d-flex align-items-center">
                            <Input type="checkbox" checked={showArchived} onChange={(e) => changeShowArchived(e)} name="showArchived" id="showArchived" />&nbsp;&nbsp;
                            <Label style={{marginTop:"10px"}} for="name">Show Archived</Label>
                        </Col>
                        <Col md="3" style={{ display: "none" }}>
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Rural Professional Organisation</Label>
                                {farmList.ruralProfessionalOrganisationList == undefined && <p><em>Loading...</em></p>}
                                {farmList.ruralProfessionalOrganisationList != undefined && farmList.ruralProfessionalOrganisationList != null &&
                                    <Input className="validate" type="select" value={ruralProfessionalOrganisation} onChange={e => {
                                        onRuralProfessionalOrganisationSelectionChanged(e);
                                    }} name="ruralProfessionalOrganisation" id="ruralProfessionalOrganisation">
                                        {farmList.ruralProfessionalOrganisationList.map(items =>
                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                        )}
                                    </Input>
                                }
                            </FormGroup>
                        </Col>
                        <Col md="3" style={{ display: "none" }}>
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Subscription</Label>
                                {farmList.subscriptionList == undefined && <p><em>Loading...</em></p>}
                                {farmList.subscriptionList != undefined && farmList.subscriptionList != null &&
                                    <Input className="validate" type="select" value={subscription} onChange={e => {
                                        onSubscriptionSelectionChanged(e);
                                    }} name="subscription" id="subscription">
                                        {farmList.subscriptionList.map(items =>
                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                        )}
                                    </Input>
                                }
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Search</Label>
                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="" />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <button onClick={exportVineyardToExcel} style={{ marginTop: "10px", float:"right" }} type="button" id="btnUpdate" className="btn btn-sm btn-success">
                                <FaFileExcel /> Export
                            </button>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th onClick={() => applySorting("uniqueIdentifier", !sorting.ascending)}>Vineyard ID</th>
                                        <th onClick={() => applySorting("name", !sorting.ascending)}>Name</th>
                                        {/*<th onClick={() => applySorting("subscriptionText", !sorting.ascending)}>Subscription</th>*/}
                                        <th onClick={() => applySorting("regionalCouncilText", !sorting.ascending)}>Regional Council</th>
                                        <th onClick={() => applySorting("catchmentText", !sorting.ascending)}>Catchment</th>
                                        {/*<th onClick={() => applySorting("supplyCompanyText", !sorting.ascending)}>Supply Company</th>*/}
                                        {/*<th onClick={() => applySorting("ruralProfessionalOrganisationText", !sorting.ascending)}>Rural Professional Organisation</th>*/}
                                        <th>Edit</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {farmItems == undefined &&
                                        <tr><td colSpan="8" style={{ textAlign: "center" }}>Loading...</td></tr>
                                    }
                                    {farmItems != undefined && farmItems != null && farmItems.map(item => (
                                        <tr key={uuid()}>
                                            <td>{item.uniqueIdentifier}</td>
                                            <td>{item.name} </td>
                                            {/*<td>{item.subscriptionText} </td>*/}
                                            <td>{item.regionalCouncilText} </td>
                                            <td>{item.catchmentText} </td>
                                            {/*<td>{item.supplyCompanyText} </td>*/}
                                            {/*<td>{item.ruralProfessionalOrganisationText} </td>*/}
                                            <td>
                                                <button type="button" onClick={(id, routePath) => open(item.id, 'editfarm')}
                                                    id="btnUpdate"
                                                    color="warning"
                                                    className="btn btn-sm btn-edit">
                                                    <FaEdit />
                                                </button>
                                            </td>
                                            <td>

                                                <button type="button"
                                                    id="btnUpdate"
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => openDeleteItemPopup(item)}>
                                                    <FaTrash />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <table style={{ display: "none" }} ref={tableRef}>
                                <thead>
                                    <tr>
                                        <th>Vineyard ID</th>
                                        <th>Name</th>
                                        {/*<th>Subscription</th>*/}
                                        <th>Regional Council</th>
                                        <th>Catchment</th>
                                        {/*<th>Supply Company</th>*/}
                                        {/*<th>Rural Professional Organisation</th>*/}
                                    </tr>
                                </thead>
                                <tbody>
                                    {farmItems == undefined &&
                                        <tr><td colSpan="8" style={{ textAlign: "center" }}>Loading...</td></tr>
                                    }
                                    {farmItems != undefined && farmItems != null && farmItems.map(item => (
                                        <tr key={uuid()}>
                                            <td>{item.uniqueIdentifier}</td>
                                            <td>{item.name} </td>
                                            {/*<td>{item.subscriptionText} </td>*/}
                                            <td>{item.regionalCouncilText} </td>
                                            <td>{item.catchmentText} </td>
                                            {/*<td>{item.supplyCompanyText} </td>*/}
                                            {/*<td>{item.ruralProfessionalOrganisationText} </td>*/}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    
                </CardBody>
            </Card>
            <Modal isOpen={showDeleteItemPopup}>
                <ModalHeader>Delete the item</ModalHeader>
                <ModalBody>
                    Do you want to delete the item ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmDeleteItemPopup}>Yes</Button>
                    <Button color="danger" onClick={closeDeleteItemPopup}>No</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default Farm;
